<ul data-cy="paginator" class="page-container" *ngIf="showPagination">
	<li
		data-cy="button-prev-page"
		class="page page-prev"
		*ngIf="pageCount > 1"
		[ngClass]="{ disabled: currentPage === 1 }"
		(click)="selectAdjacentPage(-1)"
	>
		<g-icon [icon]="icons.faChevronLeft" />
	</li>
	<li
		data-cy="button-first-page"
		class="page page-first"
		[ngClass]="{ active: currentPage === 1 }"
		(click)="selectPage(1)"
		>1</li
	>
	<li
		data-cy="button-view-prev-pages"
		class="page page-set page-set-prev"
		*ngIf="showPageSetControlsPrev"
		(click)="showPageSet(-1)"
	>
		<g-icon [icon]="icons.faLeftLong" />
	</li>
	<li
		class="page page-number"
		[attr.data-cy]="'button-select-page-' + page"
		*ngFor="let page of pages"
		[ngClass]="{ active: page === currentPage }"
		(click)="selectPage(page)"
		>{{ page }}</li
	>
	<li
		data-cy="button-view-next-pages"
		class="page page-set page-set-next"
		*ngIf="showPageSetControlsNext"
		(click)="showPageSet(1)"
	>
		<g-icon [icon]="icons.faRightLong" />
	</li>
	<li
		data-cy="button-last-page"
		class="page page-last"
		[ngClass]="{ active: currentPage === pageCount }"
		(click)="selectPage(pageCount)"
		>{{ pageCount }}</li
	>
	<li
		data-cy="button-next-page"
		class="page page-next"
		*ngIf="pageCount > 1"
		[ngClass]="{ disabled: currentPage === pageCount }"
		(click)="selectAdjacentPage(1)"
	>
		<g-icon [icon]="icons.faChevronRight" />
	</li>
</ul>
